module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "login-width"
  }, [_c('a', {
    staticClass: "login-header-logo",
    style: ({
      backgroundImage: 'url(' + _vm.logoUrl + ')'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "login-header-title"
  }, [_vm._v("卖家一键选货中心")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-main",
    style: ({
      backgroundImage: 'url(' + _vm.backPicture + ')'
    })
  }, [_c('div', {
    staticClass: "login-form",
    attrs: {
      "id": "login_form"
    }
  }, [_c('div', {
    staticClass: "login-form-title"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "login-input"
  }, [_c('div', {
    staticClass: "login-form-icon login-username"
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "login-input"
  }, [_c('div', {
    staticClass: "login-form-icon login-pw"
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "login-submit",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afd0b7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 546
// module chunks = 1